/* ─────────────────────────────────────────────────────────────
   1paysless · mobile-nav.js
   Injects a hamburger button + slide-in drawer built from the
   existing desktop .navlinks, so every page gets a mobile menu
   without editing its markup.

   Three drawer flavours (chosen via, in priority order):
     1. ?nav=a|b|c  in the URL (used by the comparison page)
     2. localStorage 'mobileNavVariant'
     3. DEFAULT_VARIANT below
   Add ?open=1 to auto-open on load (demo only).
   ───────────────────────────────────────────────────────────── */
(function () {
  "use strict";

  var DEFAULT_VARIANT = "a"; // a = classic right drawer · b = full-bleed dark · c = compact icon sheet

  // Arabic + emoji enrichment, keyed by the link label.
  var META = {
    "shop":           { ar: "تسوّق",       emoji: "🛒" },
    "categories":     { ar: "الأقسام",     emoji: "🗂️" },
    "today's deals":  { ar: "عروض اليوم",  emoji: "🔥" },
    "todays deals":   { ar: "عروض اليوم",  emoji: "🔥" },
    "deals":          { ar: "العروض",       emoji: "🔥" },
    "health corner":  { ar: "ركن الصحة",   emoji: "🌿" },
    "blog":           { ar: "المدوّنة",     emoji: "📖" },
    "wholesale":      { ar: "الجملة",       emoji: "📦" }
  };

  function param(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function pickVariant() {
    var p = (param("nav") || "").toLowerCase();
    if (p === "a" || p === "b" || p === "c") return p;
    try {
      var ls = (localStorage.getItem("mobileNavVariant") || "").toLowerCase();
      if (ls === "a" || ls === "b" || ls === "c") return ls;
    } catch (e) {}
    return DEFAULT_VARIANT;
  }

  function svgNS(d, sw) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' +
      (sw || 2.2) + '" stroke-linecap="round" stroke-linejoin="round">' + d + "</svg>";
  }

  function build() {
    var nav = document.querySelector("nav.top");
    if (!nav) return;
    var links = nav.querySelectorAll(".navlinks a");
    var actions = nav.querySelector(".navactions");
    if (!actions || !links.length) return;

    var variant = pickVariant();
    document.documentElement.setAttribute("data-mnav", variant);

    /* ── hamburger button (lives inside .navactions, shows ≤720px) ── */
    var burger = document.createElement("button");
    burger.className = "nav-burger iconbtn";
    burger.setAttribute("aria-label", "Open menu");
    burger.setAttribute("aria-expanded", "false");
    burger.innerHTML = '<span class="nav-burger__box"><span></span><span></span><span></span></span>';
    
    /* ── scrim ── */
    var scrim = document.createElement("div");
    scrim.className = "mnav-scrim";
    scrim.hidden = true;
    var inner = nav.querySelector(".inner");
    if (inner) { inner.insertBefore(burger, inner.firstChild); } else { actions.insertBefore(burger, actions.firstChild); }
    /* ── drawer ── */
    var drawer = document.createElement("aside");
    drawer.className = "mnav";
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-modal", "true");
    drawer.setAttribute("aria-label", "Menu");
    drawer.hidden = true;

    var logoSrc = (nav.querySelector(".logo img") || {}).src || "assets/logo.png";

    var linkHTML = "";
    Array.prototype.forEach.call(links, function (a, i) {
      var label = (a.textContent || "").trim();
      var key = label.toLowerCase().replace(/[^a-z' ]/g, "").trim();
      var meta = META[key] || { ar: "", emoji: "•" };
      var cls = "mnav-link" + (a.classList.contains("active") ? " is-active" : "") +
        (a.classList.contains("sale") ? " is-sale" : "");
      var ext = a.target === "_blank" ? ' target="_blank" rel="noopener"' : "";
      linkHTML +=
        '<a class="' + cls + '" href="' + a.getAttribute("href") + '"' + ext + ' style="--i:' + i + '">' +
          '<span class="mnav-emoji" aria-hidden="true">' + meta.emoji + "</span>" +
          '<span class="mnav-label">' + label + "</span>" +
          '<span class="mnav-ar" aria-hidden="true">' + meta.ar + "</span>" +
          '<span class="mnav-go" aria-hidden="true">' + svgNS('<path d="M5 12h14M13 6l6 6-6 6"/>') + "</span>" +
        "</a>";
    });

    drawer.innerHTML =
      '<div class="mnav-head">' +
        '<a href="index.html" class="mnav-logo"><img src="' + logoSrc + '" alt="1 Pays Less" /></a>' +
        '<button class="mnav-close" aria-label="Close menu">' + svgNS('<path d="M6 6l12 12M18 6L6 18"/>', 2.6) + "</button>" +
      "</div>" +
      '<div class="mnav-search">' +
        svgNS('<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>', 2) +
        '<input type="search" placeholder="Search the pantry…" aria-label="Search" />' +
      "</div>" +
      '<nav class="mnav-links" aria-label="Primary">' + linkHTML + "</nav>" +
      '<div class="mnav-actions">' +
        '<a class="mnav-act" href="https://wa.me/17039635989" target="_blank" rel="noopener">' +
          '<span class="mnav-act__ic wa">' + svgNS('<path d="M20 11.6a8 8 0 0 1-11.8 7L4 20l1.5-4.1A8 8 0 1 1 20 11.6Z"/>', 1.9) + "</span>" +
          "<span><b>WhatsApp us</b><i>+1 (703) 963-5989</i></span>" +
        "</a>" +
        '<a class="mnav-act" href="tel:+17039635989">' +
          '<span class="mnav-act__ic">' + svgNS('<path d="M5 4h4l2 5-3 2a12 12 0 0 0 5 5l2-3 5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z"/>', 2) + "</span>" +
          "<span><b>Call the store</b><i>Mon–Sat · 9am–9pm</i></span>" +
        "</a>" +
      "</div>" +
      '<div class="mnav-foot">' +
        '<span class="mnav-foot__row">' +
          '<a class="mnav-mini" href="/account" aria-label="Account">' + svgNS('<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-7 8-7s8 3 8 7"/>', 2) + "<i>Account</i></a>" +
          '<a class="mnav-mini" href="/cart" aria-label="Cart" id="mnavCartLink">' + svgNS('<path d="M3 4h3l2.5 12h10L21 8H7"/><circle cx="10" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/>', 2) + "<i>Cart</i></a>" +
        "</span>" +
        '<span class="mnav-foot__tag arabic">شكراً لتسوّقكم معنا</span>' +
      "</div>";

    document.body.appendChild(scrim);
    document.body.appendChild(drawer);

    /* ── open / close ── */
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      scrim.hidden = false;
      drawer.hidden = false;
      // force reflow so the transition runs
      void drawer.offsetWidth;
      document.documentElement.classList.add("mnav-open");
      burger.setAttribute("aria-expanded", "true");
      var first = drawer.querySelector(".mnav-close");
      if (first) first.focus();
    }
    function close() {
      document.documentElement.classList.remove("mnav-open");
      burger.setAttribute("aria-expanded", "false");
      var dur = 360;
      window.setTimeout(function () {
        if (!document.documentElement.classList.contains("mnav-open")) {
          scrim.hidden = true;
          drawer.hidden = true;
        }
      }, dur);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function toggle() {
      if (document.documentElement.classList.contains("mnav-open")) close();
      else open();
    }

    burger.addEventListener("click", toggle);
    scrim.addEventListener("click", close);
    drawer.querySelector(".mnav-close").addEventListener("click", close);
    drawer.querySelectorAll(".mnav-link").forEach(function (a) {
      a.addEventListener("click", function () {
        // let same-page hash links close the drawer too
        close();
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && document.documentElement.classList.contains("mnav-open")) close();
    });

    // auto-open for the comparison / demo view (instant, so it can't be
    // caught mid-transition / frozen inside a backgrounded iframe)
    if (param("open") === "1") {
      document.documentElement.classList.add("mnav-demo");
      open();
    }

    // expose for tooling
    window.__mnav = { open: open, close: close, toggle: toggle, variant: variant };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", build);
  } else {
    build();
  }
})();
